import { StringRelation, NumberRelation, Relations } from "./relation.types"

export const PredicateFilterTypes = {
  NUMBER: "number",
  STRING: "string",
} as const

export type PredicateFilterType =
  (typeof PredicateFilterTypes)[keyof typeof PredicateFilterTypes]

// State types with filterName included
interface BasePredicateFilterState {
  type: PredicateFilterType
  filterName: string
}

export interface StringPredicateFilterState extends BasePredicateFilterState {
  type: typeof PredicateFilterTypes.STRING
  op: StringRelation
  lhs: string
  rhs: string
}

export interface NumberPredicateFilterState extends BasePredicateFilterState {
  type: typeof PredicateFilterTypes.NUMBER
  op: NumberRelation
  lhs: number
  rhs: number
}

export type PredicateFilterState =
  | StringPredicateFilterState
  | NumberPredicateFilterState

// Default initial states for each filter type
export const DEFAULT_STRING_FILTER: Omit<
  StringPredicateFilterState,
  "filterName"
> = {
  type: PredicateFilterTypes.STRING,
  op: Relations.IS,
  lhs: "",
  rhs: "",
}

export const DEFAULT_NUMBER_FILTER: Omit<
  NumberPredicateFilterState,
  "filterName"
> = {
  type: PredicateFilterTypes.NUMBER,
  op: Relations.IS,
  lhs: 0,
  rhs: 0,
}

// Create string filter state
export function createStringFilterState(
  filterName: string,
  state: Omit<StringPredicateFilterState, "filterName">
): StringPredicateFilterState {
  return {
    ...state,
    filterName,
  }
}

// Create number filter state
export function createNumberFilterState(
  filterName: string,
  state: Omit<NumberPredicateFilterState, "filterName">
): NumberPredicateFilterState {
  return {
    ...state,
    filterName,
  }
}
// Update string filter state
export function updateStringFilterState(
  existingState: StringPredicateFilterState,
  partialUpdate: Partial<StringPredicateFilterState>
): StringPredicateFilterState {
  if (partialUpdate.type && partialUpdate.type !== existingState.type) {
    return existingState
  }
  return {
    ...existingState,
    ...partialUpdate,
  }
}

// Update number filter state
export function updateNumberFilterState(
  existingState: NumberPredicateFilterState,
  partialUpdate: Partial<NumberPredicateFilterState>
): NumberPredicateFilterState {
  if (partialUpdate.type && partialUpdate.type !== existingState.type) {
    return existingState
  }
  return {
    ...existingState,
    ...partialUpdate,
  }
}
